<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  interface Props {
    children?: import('svelte').Snippet;
  }

  let { children }: Props = $props();
</script>

<div class="attachment-disclaimer">
  <div class="warn-alert">
    <div class="alert-info">
      <div class="icon-disclaimer"><Icon value="icon-info warn" /></div>
      <div class="label">
        {@render children?.()}
      </div>
    </div>
  </div>
</div>

<style>
  .warn-alert {
    position: relative;
    width: auto;
    min-width: 200px;
    min-height: 32px;
    display: inline-flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 4px 8px;
    box-shadow: 1px 10px 27px -10px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    background-color: var(--yellow-light);
    color: var(--yellow-dark);
  }
  .attachment-disclaimer {
    padding: 0px 28px 12px 28px;
  }

  .attachment-disclaimer .alert-info {
    display: flex;
  }
  .attachment-disclaimer .alert-info .icon-disclaimer {
    margin-right: 8px;
    margin-top: 4px;
  }
</style>
